import { Table, TableCol, TablePagination, Text } from 'zens-storybook'
import React from 'react'
import { ViewProps } from 'react-native'
import { useTranslation } from 'react-i18next'
import { WorkspaceType, useWorkspaceTypes } from 'zens-store'

import { TablePaginated } from '../table'

import Specification from './specification'
import WorkspaceTypeEmpty from './empty'

interface Data {
  data: WorkspaceType
  onPress?: () => void
}

interface Props {
  companyId: number
  search?: string
  pagination?: TablePagination
  onPaginationChange?: (pagination: TablePagination) => void
}

const WorkspaceTypeTable = (props: Props) => {
  const { companyId, search, pagination = { page: 0, size: 10 }, onPaginationChange } = props
  const { t } = useTranslation()
  const workspaceTypes = useWorkspaceTypes({ search })

  const renderProperties = (workspaceType: WorkspaceType) => {
    return (
      <Text>
        {workspaceType.specifications?.map((value, index) => (
          <Specification key={value} value={value}>
            {index < workspaceType.specifications.length - 1 ? ', ' : ''}
          </Specification>
        ))}
      </Text>
    )
  }

  const cols: TableCol<WorkspaceType>[] = [
    {
      key: 'name',
      title: t('Name'),
    },
    {
      key: 'specifications',
      title: t('Properties'),
      render: renderProperties,
    },
  ]
  const rows: Data[] =
    workspaceTypes.data?.map((workspaceType) => ({
      data: workspaceType,
      href: { pathname: `/workspacetypes/${workspaceType.id}`, params: { companyId } },
    })) || []

  return (
    <TablePaginated
      rows={rows}
      cols={cols}
      pagination={pagination}
      count={rows.length}
      renderCount={() =>
        t('{{page}} of {{numberOfPages}}', {
          page: pagination.page + 1,
          numberOfPages: Math.ceil(rows.length / pagination.size),
        })
      }
      sizeLabel={t('Types per page')}
      maxSize={1000}
      onPaginationChange={onPaginationChange}
      ListEmptyComponent={<WorkspaceTypeEmpty companyId={companyId} search={search} />}
    />
  )
}

interface SkeletonProps extends ViewProps {}
const Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props
  const { t } = useTranslation()
  const cols: TableCol<WorkspaceType>[] = [
    {
      key: 'name',
      title: t('Name'),
    },
    {
      key: 'specifications',
      title: t('Properties'),
    },
  ]
  return <Table.Skeleton style={style} cols={cols} {...otherProps} />
}
WorkspaceTypeTable.Skeleton = Skeleton

export default WorkspaceTypeTable
